if (!customElements.get('featured-collection-tabs')) {
  customElements.define(
    'featured-collection-tabs',
    class QuickAddModal extends HTMLElement {
        constructor() {
            super();
            this.tabs = document.querySelectorAll('.featured-collection-tab');
            this.tabButtons = this.querySelectorAll('.featured-collection-tabs-button')
            this.tabButtons.forEach(tabButton => {
                tabButton.addEventListener('click', () => {
                    this.tabButtons.forEach(tab => {
                        tab.classList.add('_inactive')
                    })
                    tabButton.classList.remove('_inactive')

                    this.tabs.forEach(tab => {
                        tab.classList.add('_inactive')
                    })
                    document.querySelector('#' + tabButton.getAttribute('data-tab')).classList.remove('_inactive')
                });
            });
        }
    }
  );
}
